import { useState, useRef } from "react";
import { FiCopy, FiCheck } from "react-icons/fi";

const Code = ({ node, className, children, ...props }: any) => {
  const [isCopied, setIsCopied] = useState(false);
  const codeRef = useRef<HTMLElement>(null);
  const isMultiline = node?.position?.start.line !== node?.position?.end.line;

  const handleCopy = async () => {
    const codeContent = codeRef.current?.textContent || "";

    try {
      await navigator.clipboard.writeText(codeContent);
      setIsCopied(true);
      setTimeout(() => {
        setIsCopied(false);
      }, 1000);
    } catch (e) {
      console.log("error while copying the code");
    }
  };

  // For multiline code blocks, add copy functionality
  return isMultiline ? (
    <div className="relative">
      <div className="absolute top-2 right-2 z-10">
        <div className="tooltip tooltip-left" data-tip={isCopied ? "Copied" : "Copy"}>
          {isCopied ? (
            <FiCheck
              size={16}
              className="cursor-pointer p-1 bg-base-300 rounded opacity-70 hover:opacity-100 transition-opacity"
            />
          ) : (
            <FiCopy
              size={16}
              className="cursor-pointer p-1 bg-base-300 rounded opacity-70 hover:opacity-100 transition-opacity"
              onClick={handleCopy}
            />
          )}
        </div>
      </div>
      <pre className={className} {...props}>
        <code ref={codeRef}>
          {children}
        </code>
      </pre>
    </div>
  ) : (
    // For inline code, let prose handle styling completely
    <code className={className} {...props}>
      {children}
    </code>
  );
};

export default Code;
